import { action, flow, makeObservable } from 'mobx';
import { ApiResponse, GlobalStore, GridStore } from '@roc/feature-app-core';
import { LoansInPendingStatusService } from '../services/loansInPendingStatusService';

export abstract class LoansInPendingStatusBaseStore {
  globalStore: GlobalStore;
  service: LoansInPendingStatusService;
  loansInPendingStatusGridStore: GridStore;

  constructor(globalStore: GlobalStore) {
    this.globalStore = globalStore;
    this.service = new LoansInPendingStatusService();

    this.loansInPendingStatusGridStore = new GridStore(
      () => this.fetchLoansInPendingStatusGrid(),
      null,
      50
    );

    makeObservable(this, {
      reset: action,
      resetAndFetchGridData: flow,
      fetchOnlyGridData: flow,
    });
  }

  private async fetchLoansInPendingStatusGrid(): Promise<ApiResponse> {
    try {
      const meta = this.loansInPendingStatusGridStore.gridData.meta;
      const filters = meta.filters || {};
      const dropdownFilters = meta.dropdownFilters || {};

      const pageNumber = meta.pageNumber;
      const pageSize = meta.pageSize;
      const sortBy = meta.sortBy;
      const sortDir = meta.sortDir;

      const params: Record<string, string> = {
        page: String(pageNumber),
        pageSize: String(pageSize),
        filters: JSON.stringify(filters),
        dropdownFilters: JSON.stringify(dropdownFilters),
      };

      if (sortBy) params.sortBy = sortBy;
      if (sortDir) params.sortDir = sortDir;

      const urlParams = new URLSearchParams(params).toString();

      return await this.service.getLoansInPendingStatusGrid(
        urlParams
      );

    } catch (error) {
      this.globalStore.notificationStore.showErrorNotification({
        message: 'Error Fetching Loan In Pending Status Dashboard.',
      });
      return {
        data: {
          rows: [],
          meta: {
            total: 0,
            pageNumber: 1,
          },
        },
        headers: {},
      };
    }
  }

  *resetAndFetchGridData() {
    this.loansInPendingStatusGridStore.reset();
    yield this.loansInPendingStatusGridStore.fetchGridData();
  }

  *fetchOnlyGridData() {
    yield this.loansInPendingStatusGridStore.fetchGridData();
  }

  abstract reset(): void;

}
